/**
 * Zentrale Anwendungskonfiguration
 * =================================
 * 
 * Alle wichtigen Konfigurationsparameter für das Frontend
 * Nur hier muss die Backend-URL angepasst werden!
 */

// Backend API Konfiguration
const API_CONFIG = {
  // Haupt-Backend URL - HIER ändern für andere Umgebungen
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8181/api',
  
  // Timeout-Einstellungen
  TIMEOUT: 30000, // 30 Sekunden
  
  // API-Endpunkte (relativ zur BASE_URL)
  ENDPOINTS: {
    AUTH: '/auth',
    BOOKMARKS: '/bookmarks', 
    IMPORT: '/import',
    HEALTH: '/status/health',
    ERROR_TRACKING: '/error-tracking'
  },
  
  // Error Tracking API Key
  ERROR_TRACKING_KEY: process.env.REACT_APP_ERROR_TRACKING_KEY || 'test-api-key-local-development'
};

// Frontend Konfiguration
const UI_CONFIG = {
  // Theme-Einstellungen
  DEFAULT_THEME: 'light',
  THEME_STORAGE_KEY: 'bookmark-manager-theme',
  
  // Sprach-Einstellungen
  DEFAULT_LANGUAGE: 'de',
  LANGUAGE_STORAGE_KEY: 'bookmark-manager-language',
  
  // Pagination
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  
  // File Upload
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_FILE_TYPES: ['.html', '.json']
};

// Security Konfiguration
const SECURITY_CONFIG = {
  // JWT Token
  TOKEN_STORAGE_KEY: 'authToken',
  TOKEN_REFRESH_THRESHOLD: 5 * 60 * 1000, // 5 Minuten vor Ablauf
  
  // Session
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000, // 24 Stunden
  
  // Password Requirements
  MIN_PASSWORD_LENGTH: 6,
  REQUIRE_SPECIAL_CHARS: false
};

// Development/Debug Konfiguration
const DEBUG_CONFIG = {
  // Logging
  ENABLE_CONSOLE_LOGS: process.env.NODE_ENV === 'development',
  ENABLE_API_LOGS: process.env.NODE_ENV === 'development',
  
  // Mock Data
  USE_MOCK_DATA: false,
  
  // Error Reporting
  SHOW_DETAILED_ERRORS: process.env.NODE_ENV === 'development'
};

// Exportierte Hauptkonfiguration
const APP_CONFIG = {
  API: API_CONFIG,
  UI: UI_CONFIG,
  SECURITY: SECURITY_CONFIG,
  DEBUG: DEBUG_CONFIG,
  
  // Utility-Funktionen
  getApiUrl: (endpoint = '') => {
    return `${API_CONFIG.BASE_URL}${endpoint}`;
  },
  
  getAuthApiUrl: (endpoint = '') => {
    return `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.AUTH}${endpoint}`;
  },
  
  getBookmarkApiUrl: (endpoint = '') => {
    return `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.BOOKMARKS}${endpoint}`;
  },
  
  getImportApiUrl: (endpoint = '') => {
    return `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.IMPORT}${endpoint}`;
  },
  
  getErrorTrackingApiUrl: (endpoint = '') => {
    return `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.ERROR_TRACKING}${endpoint}`;
  },
  
  // Environment helpers
  isDevelopment: () => process.env.NODE_ENV === 'development',
  isProduction: () => process.env.NODE_ENV === 'production',
  
  // API Key helper
  getErrorTrackingKey: () => API_CONFIG.ERROR_TRACKING_KEY
};

export default APP_CONFIG;

// Einzelne Konfigurationen für spezifische Importe
export { API_CONFIG, UI_CONFIG, SECURITY_CONFIG, DEBUG_CONFIG };